import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { OfferStreamRecord } from '../_models';
import { ListResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OfferStreamHistoryService {

  constructor(private http: HttpClient) { }

  getAll(filter: any): Observable<any>  { //listing
    return this.http.post(`${environment.apiUrl}/offer-stream/history/list`, filter)
    .pipe(
      map((data: any) => {
        if(data.status == 1 && data.data && data.data.list){
            return new ListResponse().deserialize(data, OfferStreamRecord);
        }else{
           return {status:null, msg: data.msg};
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

}
